var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"float-right dont_print",attrs:{"color":"primary","fab":"","x-small":"","elevation":"0","data-html2canvas-ignore":"true"},on:{"click":_setup.props.onClick}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-content-save")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }